import React, { Component, Suspense } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { observer, Provider } from 'mobx-react';
import { css } from 'styled-components';
import './app.less';
import feathers from '../feathers';
import Empty from '../components/empty';
import Loader from '../components/loader';
import AppStore from './store';
import uiStore from './ui-store';
import IncompleteAccountStore from '../components/incomplete-account/store';
import Routes from './routes';
import config from '../config';
import { initializeTracking } from '../tracker';

const app = new AppStore(feathers);

const warningTitleCSS = css`
  color: red;
  font-size: 60px;
  font-weight: bold;
  -webkit-text-stroke: 1px black;
`.toString();

const warningDescCSS = css`
  font-size: 18px;
`.toString();

console.log('%cWARNING', warningTitleCSS);
console.log('%cThis browser feature is intended for developers only. Do NOT copy-paste any code here, or run any scripts, as doing this may cause your account to be compromised!', warningDescCSS);

@observer
class App extends Component {
  constructor () {
    super();
    if (process.browser) {
      initializeTracking();
      if (config.helpscoutBeaconId && config.helpscoutBeaconEnabled && window.Beacon) {
        window.Beacon('init', config.helpscoutBeaconId);
      }
    }
  }

  render () {
    if (app.authStatus.isPending) {
      return <Loader />;
    }

    return (
      <Provider
        app={app}
        client={feathers}
        uiStore={uiStore}
        incompleteAccount={new IncompleteAccountStore(app)}>
        <HelmetProvider>
          <Suspense fallback={(<Loader />)}>
            <Empty>
              <Helmet>
                <link rel="shortcut icon" href={config.favIconUrl} />
                <link rel="icon" type="image/png" href={config.favIconUrl} />
              </Helmet>
              <Routes />
            </Empty>
          </Suspense>
        </HelmetProvider>
      </Provider>
    );
  }
}

export default App;
